const colorMap = {
    indigo: "bg-indigo-100 text-indigo-700",
    green: "bg-green-100 text-green-700",
    amber: "bg-amber-100 text-amber-700",
    rose: "bg-rose-100 text-rose-700",
};

export default function KpiCard({ title, value, note, color = "indigo" }) {
    return (
        <div className="rounded-2xl border border-gray-200 bg-white p-4 dark:border-white/10 dark:bg-navy-800">
            <div className="text-sm text-gray-500">{title}</div>
            <div className="mt-1 text-2xl font-semibold dark:text-white">{value}</div>
            {note && (
                <div className={`mt-2 inline-block rounded-lg px-2 py-1 text-xs ${colorMap[color]}`}>
                    {note}
                </div>
            )}
        </div>
    );
}
